import { Analytics } from '@util/Analytics';
import { Auth } from '@util/Auth';
import { AuthValidation } from '@util/AuthValidation';
import { ActionType } from '../../ActionTypes';
import { store as baseStore } from '../../Store';
import { handleUserError } from '../Utils';

export async function resetPassword(email: string, store = baseStore): Promise<void> {
  try {
    store.dispatch({ type: ActionType.RESET_PASSWORD_LOADING });

    AuthValidation.validateResetPassword(email);

    await Auth.sendPasswordResetEmail(email);

    Analytics.track({ event: Analytics.Event.a_password_reset_sent });
    store.dispatch({ type: ActionType.RESET_PASSWORD_SUCCESS });
  } catch (rawError) {
    const error = handleUserError(rawError);
    Analytics.track({ event: Analytics.Event.a_password_reset_failed });
    store.dispatch({ type: ActionType.RESET_PASSWORD_FAILURE, error });
  }
}
